module.exports = __webpack_public_path__ + "img/portrait.5588814d.jpg";